import { laTribuClipping } from './la-tribu';

export const GVAZ_TEMPLATES = [laTribuClipping];

export { laTribuClipping };
